export var LibraryOrderBy;
(function (LibraryOrderBy) {
    LibraryOrderBy["MODIFIED_DATE"] = "modified_date";
    LibraryOrderBy["CREATED_DATE"] = "created_date";
    LibraryOrderBy["NAME"] = "name";
})(LibraryOrderBy || (LibraryOrderBy = {}));
/**
 * Enum for library owner filter
 * (If you update this list, also update LibraryFilter.matches/getRelationToFilter.)
 * @enum {string}
 */
export var LibraryOwnerFilter;
(function (LibraryOwnerFilter) {
    /**
     * Personal libraries created in User Storage that are specifically stored inside the sync group: `/assets/adobe-libraries`
     * Excludes CCI Project Libraries.
     */
    LibraryOwnerFilter["Personal"] = "private";
    /**
     * Bookmarked public libraries.
     * Currently will be ignored if combined with other ownership types.
     */
    LibraryOwnerFilter["Public"] = "public";
    /**
     * Bookmarked incoming libraries. This includes:
     * - Libraries shared directly with the user that the user has accepted the invite to
     * - CCI Project Libraries which live in User Storage (`/users/{userId}` in ESM, `/` in USM and for unified users)
     * - Project Libraries the user has followed (After SMU, these will all live in `/projects/{projectName}`)
     */
    LibraryOwnerFilter["Incoming"] = "incoming";
    /**
     * Everything the user has acccess to that is not in User Storage, except public libraries.
     * Includes: Project libraries, Incoming libraries (except CCI Project Libraries since they are in User Storage)
     * Excludes: Public libraries, CCI Project Libraries, Private Libraries
     */
    LibraryOwnerFilter["Discovery"] = "discovery";
    /**
     * A subset of 'discovery' that excludes already bookmarked libraries.
     */
    /**
     * All of the above except public libraries currently (until supported by USS).
     * If combined with other owner types, the others will be ignored.
     */
    LibraryOwnerFilter["All"] = "all";
})(LibraryOwnerFilter || (LibraryOwnerFilter = {}));
export var LibraryProjectFilterEnum;
(function (LibraryProjectFilterEnum) {
    /**
     * Include all project libraries.
     */
    LibraryProjectFilterEnum["All"] = "all";
    /**
     * Do not include any project libraries.
     */
    LibraryProjectFilterEnum["None"] = "none";
})(LibraryProjectFilterEnum || (LibraryProjectFilterEnum = {}));
/**
 * @experimental API May change.
 *
 * Enum for library reference filter
 * This filter must be used in conjunction with a projectID via the LibraryProjectFilter.
 * @enum {string}
 */
export var LibraryReferenceFilter;
(function (LibraryReferenceFilter) {
    /**
     * Return all libraries beneath the project or referenced by the project
     */
    LibraryReferenceFilter["All"] = "all";
    /**
     * Include only libraries referenced by the project
     */
    LibraryReferenceFilter["Only"] = "only";
})(LibraryReferenceFilter || (LibraryReferenceFilter = {}));
export var LibraryRolesFilter;
(function (LibraryRolesFilter) {
    /**
     * Include libraries that have no roles
     */
    LibraryRolesFilter["None"] = "none";
    /**
     * Include libraries that have at least one role where role.type === 'brand'
     */
    LibraryRolesFilter["Brand"] = "brand";
    /**
     * Include training set libraries. Currently the default, as it is the only option.
     */
    LibraryRolesFilter["TrainingSet"] = "cm_training_set";
})(LibraryRolesFilter || (LibraryRolesFilter = {}));
/**
 * This enum is used for filtering the library list view for brands specifically based on it's publishing related app metadata.
 * This filter is only usable if the brand role is true.
 *
 * There are three types of brands that exist in the data:
 * 1. Published brands -- These are the brands that have brand:publishedFrom in their app metadata.
 * Nobody is able to update these brands directly, they can only be updated by publishing changes from their draft brand counterpart (which is what brand:publishedFrom points to).
 *
 * 2. Draft brands with a published counterpart -- These are the brands that have brand:publishedTo in their app metadata.
 * These brands do NOT show up in the list of brands, but still can be accessed when a user goes to edit a published brand.
 * This is so we can maintain a "Draft" state for a published brand so brand creators can make revisions without updating the published copy that is currently in use.
 *
 * 3. Draft brands that are unpublished -- These are brands that are not part of a published brand in any way, and thus have neither brand:publishedFrom nor brand:publishedTo.
 * These brands are editable, and do show up in the brands listing view.
 */
export var BrandPublishMetadataFilter;
(function (BrandPublishMetadataFilter) {
    /**
     * Includes: Published brands
     *
     * Excludes: Unpublished draft brands, Draft brands with a published counterpart
     */
    BrandPublishMetadataFilter["PublishedBrands"] = "publishedBrands";
    /**
     * Includes: Published brands, Unpublished draft brands
     *
     * Excludes: Draft brands with a published counterpart
     */
    BrandPublishMetadataFilter["AllBrands"] = "allBrands";
    /**
     * Includes: Unpublished draft brands, Draft brands with a published counterpart
     *
     * Excludes: Published brands
     */
    BrandPublishMetadataFilter["AllEditableBrands"] = "allEditableBrands";
})(BrandPublishMetadataFilter || (BrandPublishMetadataFilter = {}));
